var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{staticClass:"notes-list"},_vm._l((_vm.resourcesItems),function(resourceItem){return _c('NoteItem',{key:resourceItem.upload_id,attrs:{"resourceItem":resourceItem}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }